<div class="container-fluid mt-2">

  <p-panel header="Importação do Arquivo" styleClass="p-shadow-3">
    <p-toolbar styleClass="mb-4 p-shadow-3">

  <div class="row w-100">

    <div class="col-auto">
      <button
        pButton
        label="Importação"
        icon="pi pi-file"
        (click)="showDialog()"
        class="p-button-sm">
      </button>

      <button
        pButton
        icon="pi pi-refresh"
        pTooltip="Atualizar Tabela"
        (click)="recarregaDados()"
        class="p-button-sm ml-2">
      </button>
    </div>

    <div class="col d-flex justify-content-end">
    <button
    pButton
    class="p-button-outlined p-button-secondary p-button-sm float-right"
    type="button"
    (click)="exportExcel()">
    <i class="fa fa-download mr-1"></i>Export Excel
</button>
    </div>

  </div>

  <div class="row mt-2">
    <div class="col-md col-sm pl-3">
      <div class="p-d-flex filter-margin">
            <span class="p-input-icon-left p-ml-auto">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                placeholder="Filtro Geral..." class="p-inputText-mobile" />
            </span>
          </div>
        </div>
      </div>
    </p-toolbar>

    <p-table #dt [columns]="selectedColumns" [columns]="cols" [value]="dados" [rowHover]="true"
      [paginator]="dados?.length > 10" [rows]="10" [showCurrentPageReport]="true" [loading]="loading"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines p-datatable-responsive-demo p-shadow-3"
      currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registro(s)"
      [rowsPerPageOptions]="[10,20,30,50,100]" [autoLayout]="true" sortMode="multiple"
      [globalFilterFields]="['codigo','categoriaItem','status']" paginatorDropdownAppendTo="body">

      <ng-template pTemplate="caption">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field col-md-2 col-sm">
            <span for="codigo" class="sm-font">Código</span>
            <span class="p-float-label">
              <p-dropdown styleClass="p-inputtext-sm" field="codigo" id="codigo" [options]="codigos"
                [(ngModel)]="filtros.codigo" placeholder="Selecione o Código..." [filter]="true" appendTo="body"
                [virtualScroll]="true" itemSize="30">
              </p-dropdown>
            </span>
          </div>
          <div class="p-field col-md-2 col-sm">
            <span for="tipo" class="sm-font">Categoria Item</span>
            <span class="p-float-label">
              <p-dropdown styleClass="p-inputtext-sm" id="categoriaItem" field="categoriaItem"
                [options]="categoriaItemSelecionar" [(ngModel)]="filtros.categoriaItem"
                placeholder="Selecione a Categoria..." appendTo="body">
              </p-dropdown>
            </span>
          </div>
          <div class="p-field col-md-2 col-sm">
            <span for="tipo" class="sm-font">Subgrupo</span>
            <span class="p-float-label">
              <p-dropdown styleClass="p-inputtext-sm" id="subgrupo" field="subgrupo" [options]="subgrupoSelecionar"
                [(ngModel)]="filtros.subgrupo" placeholder="Selecione o Subgrupo..." appendTo="body">
              </p-dropdown>
            </span>
          </div>
          <div class="col-md col-sm mt-3 pl-3 pr-3 align-items-center remove-margins">
            <button pButton label="Filtrar" icon="pi pi-filter" (click)="filtrosAPI()"
              class="p-button-sm p-button-secondary p-button-mobile-filter mt-2" style="width: auto;"
              [disabled]="botaoDisable">
            </button>
            <button pButton label="" icon="pi pi-filter-slash" pTooltip="Limpar Filtros" (click)="limpafiltros($event)"
              class="p-button-sm p-button-secondary p-button-mobile-filter ml-1 mt-2">
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template #message pTemplate="emptymessage" let-columns>
        <tr *ngIf="dados?.length != 0">
          <td id="message" [attr.colspan]="columns.length" class="text-center bg-no-records p-shadow-3"
            style="padding: 20px;">
            <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field"
            style="background-color:#212529;color:white;border-color: rgb(105, 105, 105);"
            [ngStyle]="{'width': col.width}">
            {{col.header}}
            <p-sortIcon [field]="col.field" class="p-sortable-colum"
              *ngIf="col.field !== 'selecionar' && col.field !== 'edit'">
            </p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <div *ngIf="col.field != 'status'">
              {{ col.type ? col.type.transform(dados[col.field], col.arg1) : dados[col.field]}}
            </div>

            <p-badge *ngIf="col.field == 'status' && dados[col.field] == 0 && dados.qtdeErros == 0"
              value="Importando..." severity="warning" size="large" styleClass="d-block">
            </p-badge>

            <p-badge *ngIf="col.field == 'status' && dados[col.field] == 1 && dados.qtdeErros == 0"
              value="Pronto p/ Processar" severity="info" size="large" styleClass="d-block">
            </p-badge>
            <p-badge *ngIf="col.field == 'status' && dados.qtdeErros > 0" value="Corrigir erros" severity="danger"
              size="large" styleClass="d-block">
            </p-badge>

            <span *ngIf="col.field == 'status' && dados[col.field] == 2 && dados.qtdeErros == 0"
              class="p-badge p-badge-lg p-badge-primary d-block">
              Processando
              <i class="ml-1 pi pi-spin pi-spinner"></i>
            </span>
            <p-badge *ngIf="col.field == 'status' && dados[col.field] == 3 && dados.qtdeErros == 0" value="Pronto"
              size="large" severity="success" styleClass="d-block">
            </p-badge>

            <!-- <button pTooltip="Detalhes" pButton pRipple icon="far fa-file-alt"
              class="p-button-rounded p-button-secondary p-btn-sm p-mr-1" (click)="detalhes(dados)"
              *ngIf="col.field === 'edit'">
            </button>
             -->

            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info p-btn-sm p-mr-1"
              (click)="editDados(dados)" pTooltip="Editar" *ngIf="col.field === 'edit'">
            </button>

          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="card" *ngIf="dados?.length === 0">
      <div class="card-body bg-no-records p-shadow-3">
        <p class="full-width main-div text-muted">Nenhum Registro Encontrado</p>
      </div>
    </div>

  </p-panel>

</div>


<p-dialog class="p-dialog-import" header="Importação de Arquivos" [(visible)]="displayImport" [style]="{width: '785px'}"
  [modal]="true">

  <div class="d-flex justify-content-center">
    <p-progressSpinner *ngIf="progress"></p-progressSpinner>
  </div>

  <p-fileUpload *ngIf="!progress" #fileUploader mode="advanced" fileLimit="1" name="myfile[]" customUpload="true"
    accept=".xls,.xlsx" (uploadHandler)="onUpload($event)" (onSelect)="onSelectFile($event,fileUploader)"
    (onProgress)="progressReport($event)" (onRemove)="onRemoveFile($event)" (onClear)="onRemoveFile()"
    chooseLabel="Arquivo" uploadLabel="Enviar" cancelLabel="Cancelar">
    <ng-template let-file pTemplate='file'>
      <div class="container">
        <div class="row">
          <div class="col col-sm d-flex align-items-center ml-3">
            <div>{{file.name}} - {{file.size | filesize}}</div>
          </div>
          <div class="col col-sm align-items-center">
            <div>
              <button class="float-right mr-3" icon="pi pi-times" pButton type="button"
                (click)="removeFile(file, fileUploader)">
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-fileUpload>
  <p-progressBar *ngIf="!progress" [value]="progressBarPerc"></p-progressBar>
  <div class="jumbotron mt-1">
    <p class="h5">Informações:</p>
    <ul>
      <li>
        <legend class="text-muted h6">Só é permitido arquivo do tipo XLS ou XLSX.</legend>
      </li>
      <li>
        <legend class="text-muted h6">A importação de Arquivos pode demorar. Aguarde...</legend>
      </li>
    </ul>
  </div>
</p-dialog>

<p-confirmDialog key="tipoItem" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="tipoItem" position="bottom-right"></p-toast>

<p-dialog [(visible)]="dadosDialog" [style]="{width: '480px'}" header="Editar" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="codigo">Código</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.codigo" inputId="codigo"
          placeholder="Automático" appendTo="body" disabled>
      </div>
      <div class="p-field p-col-12">
        <label for="categoriaItem">Categoria Item</label>
        <p-dropdown styleClass="p-inputtext-sm" [(ngModel)]="dado.categoriaItem" inputId="categoriaItem"
          [options]="categoriaItemSelecionar" placeholder="Selecione a Categoria" appendTo="body">
          <ng-template let-option pTemplate="item">
            <span>{{option.label}}</span>
          </ng-template>
        </p-dropdown>
        <small class="p-invalid text-danger" *ngIf="submitted && !dado.categoriaItem">Categoria é
          Obrigatório!</small>
      </div>
      <div class="p-field p-col-12">
        <label for="subgrupo">Subgrupo</label>
        <input pInputText styleClass="p-inputtext-sm" [(ngModel)]="dado.subgrupo" inputId="subgrupo"
          placeholder="Automático" appendTo="body">
      </div>
      <div class="p-field p-col-12">
        <label for="embalagem">Embalagem</label>
        <p-inputNumber styleClass="p-inputtext-sm" [(ngModel)]="dado.embalagem" inputId="embalagem"
          placeholder="Automático" appendTo="body">
        </p-inputNumber>
      </div>
      <div class="p-field p-col-12">
        <label for="classe">Classe</label>
        <p-inputNumber styleClass="p-inputtext-sm" [(ngModel)]="dado.classe" inputId="classe"
          placeholder="Automático" appendTo="body">
        </p-inputNumber>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-text" (click)="saveDados()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog key="categoriaItem" [style]="{width: '450px'}"></p-confirmDialog>
<p-toast key="categoriaItem" position="bottom-right"></p-toast>